export default __webpack_public_path__ + "static/06.05-60053c986be44c4d5f453634eeee397f.png";